import React from 'react';
import { Button, Typography, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CandidateDialog from './CandidateDialog';
import type { Partner } from '../../../../components/LeadFormIndex/types';
import { leadResultCategory } from './analyticsPages';
import {
  offerBody,
  OFFER_CTA,
  OFFER_TITLE,
} from './copy';

type ComplementOfferProps = {
  partner: Partner;
  token: string;
  pageCategory?: string;
  leadApproved?: boolean;
};

export default function ComplementOffer({
  partner, token, pageCategory = leadResultCategory(), leadApproved = true,
}: ComplementOfferProps) {
  const theme = useTheme();
  const [pickerOpen, setPickerOpen] = React.useState(false);
  const accentColor = partner.config.styles?.secondaryColor
    || partner.config.styles?.primaryColor
    || theme.palette.secondary.main;
  const cardBackground = partner.config.styles?.backgroundSecondaryColor
    || theme.palette.background.defaultSecondary;

  return (
    <div
      data-pw="complement-offer"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginTop: 16,
        padding: '12px 14px',
        borderRadius: 12,
        backgroundColor: cardBackground,
        border: `1px solid ${alpha(accentColor, 0.25)}`,
        boxSizing: 'border-box',
      }}
    >
      <Typography
        variant="caption"
        fontWeight="bold"
        align="center"
        component="div"
        gutterBottom
        style={{ fontSize: 13, lineHeight: 1.35 }}
      >
        {OFFER_TITLE}
      </Typography>
      <Typography
        variant="caption"
        align="center"
        component="div"
        style={{
          marginBottom: 10,
          fontSize: 12,
          lineHeight: 1.4,
        }}
      >
        {offerBody(leadApproved)}
      </Typography>
      <Button
        data-pw="complement-offer-button"
        variant="outlined"
        size="small"
        endIcon={<PersonAddIcon fontSize="small" />}
        onClick={() => setPickerOpen(true)}
        style={{
          borderRadius: 8,
          color: accentColor,
          borderColor: accentColor,
          fontSize: 13,
          padding: '4px 12px',
        }}
      >
        {OFFER_CTA}
      </Button>
      <CandidateDialog
        open={pickerOpen}
        token={token}
        pageCategory={pageCategory}
        onClose={() => setPickerOpen(false)}
      />
    </div>
  );
}

ComplementOffer.defaultProps = {
  pageCategory: leadResultCategory(),
  leadApproved: true,
};
